import Tabs from '@material-ui/core/Tabs';
import { createStyles, withStyles, Theme } from '@material-ui/core';


export const PasslyTabs = withStyles((theme: Theme) =>
    createStyles({
        root: {
            backgroundColor: theme.palette.common.white
        },
        indicator: {
            backgroundColor: theme.palette.primary.main,
        },
    })
)(Tabs);
